import React from 'react'

const EmployerNotifications = () => {
  return (
    <div className="col-lg-4">
  <div className="user-profile-card">
    <h4 className="user-profile-card-title">Notifications</h4>
    <div className="user-notification">
      <div className="user-notification-item">
        <a href="#">
          <div className="user-notification-icon">
            <i className="far fa-briefcase" />
          </div>
          <div className="user-notification-info">
            <p>
              You Have New Application For <b>Web Designer</b>!
            </p>
            <span>just now</span>
          </div>
        </a>
      </div>
      <div className="user-notification-item">
        <a href="#">
          <div className="user-notification-icon">
            <i className="far fa-envelope" />
          </div>
          <div className="user-notification-info">
            <p>
              Tesla Jonsin Has Sent You <b>Private Message</b>!
            </p>
            <span>15 min ago</span>
          </div>
        </a>
      </div>
      <div className="user-notification-item">
        <a href="#">
          <div className="user-notification-icon">
            <i className="far fa-briefcase" />
          </div>
          <div className="user-notification-info">
            <p>
              <b>Henry Wilson</b> Applied For A Job Senior Product Designer
            </p>
            <span>2 months ago</span>
          </div>
        </a>
      </div>
      <div className="user-notification-item">
        <a href="#">
          <div className="user-notification-icon">
            <i className="far fa-comment" />
          </div>
          <div className="user-notification-info">
            <p>
              You Have New Review For <b>#53454</b> This List
            </p>
            <span>15 days ago</span>
          </div>
        </a>
      </div>
    </div>
  </div>
</div>
  )
}

export default React.memo(EmployerNotifications);
